import { useMemo } from 'react';

/**
 * Хук для проверки наличия сегмента в текущем URL (`pathname`).
 *
 * Работает только с `window.location.pathname`:
 * - не учитывает query-параметры
 * - не даёт ложных совпадений (проверка по сегментам пути)
 *
 * Примеры:
 * - `/company/5/purchase` + `segment = "company"` → true
 * - `/estimate/23808/purchase` + `segment = "company"` → false
 *
 * @param {string} segment - Сегмент маршрута для проверки (без `/`)
 * @returns {boolean} `true`, если сегмент присутствует в URL
 */

export const useIsRouteSegment = (segment: string): boolean =>
    useMemo(() => {
        if (typeof window === 'undefined') return false;

        const segments = window.location.pathname.split('/').filter(Boolean);
        return segments.some((route) => route === segment);
    }, [segment]);
